import axios from '@/plugins/axios'

export default {
    getUserMe() {
        return axios.httpApi('user/me')
    },
    registerGcmToken(FCMToken) {
        return axios.httpApi.post('device_token/_register', { token: FCMToken })
    }
}